import {
  type Id as ToastId,
  toast,
  type ToastContent,
  type ToastOptions,
} from 'react-toastify';

export type { ToastId };

export function clearToasters(): void {
  return toast.dismiss();
}

export function closeToaster(id: ToastId): void {
  return toast.dismiss(id);
}

export function showToaster(
  message: ToastContent,
  options?: ToastOptions
): ToastId {
  return toast(message, options);
}

export function showSuccessToaster(
  message: string,
  options?: ToastOptions
): ToastId {
  return toast.success(message, options);
}

export function showErrorToaster(
  message: string,
  options?: ToastOptions
): ToastId {
  return toast.error(message, options);
}

export function showWarningToaster(
  message: string,
  options?: ToastOptions
): ToastId {
  return toast.warn(message, options);
}

export function showInfoToaster(
  message: string,
  options?: ToastOptions
): ToastId {
  return toast.info(message, options);
}
